import Slider from './src/main';

Slider.install = function(Vue) {
  Vue.component(Slider.name, Slider);
};

export default Slider;



// WEBPACK FOOTER //
// ./src/components/slider/index.js